﻿$.fn.dxCtrlDataSaisieVisu = function custom_dxCtrlDataSaisieVisu(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrldatasiaisevisu dx-ctrl");
        this.createInstance(new cdxCtrlDataSaisieVisu(this, option));
    }
    return this;
}

window.cdxCtrlDataSaisieVisu = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        if (option.dataSaisie.con_nom.length > 0 || option.dataSaisie.con_prenom.length > 0) {
            var $Div = $("<div style='font-weight:bold;'/>").appendTo(container)
            var txt = ""
            if (option.dataSaisie.con_nom.length > 0) txt += option.dataSaisie.con_nom.toUpperCase()
            if (option.dataSaisie.con_prenom.length > 0) txt += (txt.length > 0 ? " " : "") + option.dataSaisie.con_prenom
            $Div.text(txt)
        }
        if (option.dataSaisie.id_type_client != "0") {
            var $Div = $("<div style='font-weight:bold;font-size:130%;'/>").appendTo(container).text(option.dataSaisie.nom_str)
            var txtHtml = ""
            switch (parseInt(option.dataSaisie.id_type_client)) {
                case 0: break;
                case 1:
                    if (option.dataSaisie.siret.length > 0) {
                        txtHtml = "<span style='opacity:0.6;'>Siret: </span>" + option.dataSaisie.siret
                    }
                    break;
                case 2:
                    if (option.dataSaisie.tvaintra.length > 0) {
                        if (txtHtml.length > 0) txtHtml += "<span> &bull; </span>"
                        txtHtml += "<span style='opacity:0.6;'>Tva intra: </span>" + option.dataSaisie.tvaintra
                    }
                    break;
                case 3:
                    break;
            }
            $("<div/>").appendTo(container).html(txtHtml)
        }

        if (option.dataSaisie.adr_ad1.length > 0 || option.dataSaisie.adr_ad2.length > 0 || option.dataSaisie.adr_ad3.length > 0 ||
            option.dataSaisie.adr_cp.length > 0 || option.dataSaisie.adr_ville.length > 0 || option.dataSaisie.adr_pays.length > 0) {
            if (option.dataSaisie.adr_ad1.length > 0) $("<div/>").appendTo(container).text(option.dataSaisie.adr_ad1)
            if (option.dataSaisie.adr_ad2.length > 0) $("<div/>").appendTo(container).text(option.dataSaisie.adr_ad2)
            if (option.dataSaisie.adr_ad3.length > 0) $("<div/>").appendTo(container).text(option.dataSaisie.adr_ad3)
            var txt = ""
            if (option.dataSaisie.adr_cp.length > 0) txt = option.dataSaisie.adr_cp
            if (option.dataSaisie.adr_ville.length > 0) txt += (txt.length > 0 ? " " : "") + option.dataSaisie.adr_ville
            if (option.dataSaisie.adr_pays.length > 0) txt += (txt.length > 0 ? " " : "") + option.dataSaisie.adr_pays
            if (txt.length > 0) $("<div/>").appendTo(container).text(txt)
        }

        if (option.dataSaisie.adresse_email.length > 0 || option.dataSaisie.tel_sms.length > 0) {
            var $Div = $("<div/>").appendTo(container)
            if (option.dataSaisie.adresse_email.length > 0) $("<u>" + option.dataSaisie.adresse_email + "</u>").appendTo($Div)
            if (option.dataSaisie.adresse_email.length > 0 && option.dataSaisie.tel_sms.length > 0) $("<span> &bull; </span>").appendTo($Div)
            var tel = new cTelephone(option.dataSaisie.tel_code_pays, option.dataSaisie.tel_sms)
            $("<span>" + tel.mGetValueMiseEnForme() + "</span>").appendTo($Div)
        }

    }

    this.mReload = function () { mConstruit() }

    this.element = function () { return container }

    mConstruit();
}


